import React, { Component } from 'react';
import { connect } from 'react-redux';

import { KeyLicenseTypes } from '../common/keyLicenseTypes';
import ConfirmDialog from '../components/confirmDialog';
import * as permanentLicensesActions from '../store/permanentLicensesSlice';
import { permanentLicensesSelectors } from '../store/permanentLicensesSlice';
import * as temporaryLicensesActions from '../store/temporaryLicensesSlice';
import { temporaryLicensesSelectors } from '../store/temporaryLicensesSlice';
import { showModalMessage } from '../store/modalsSlice';
import { unwrapResult } from '@reduxjs/toolkit';

class DeactivateLicConfirmDialog extends Component {

  constructor(props) {
    super(props);
    this.onConfirm = this.onConfirm.bind(this);
    this.deactivateHandler = null;

    switch (this.props.temporalType) {
      case KeyLicenseTypes.OnlinePermanent:
        this.deactivateHandler = this.props.deactivatePermLic;
        this.errorName = 'permanentLicenseError';
        break;
      case KeyLicenseTypes.OnlineTemporary:
        this.deactivateHandler = this.props.deactivateTempLic;
        this.errorName = 'temporaryLicenseError';
        break;
      default:
        break;
    }
  }

  onConfirm() {
    const { licenseId } = this.props;
    if (this.deactivateHandler === null)
      return;
    this.deactivateHandler({ licenseId }).then(unwrapResult).catch(() => {
      this.props.showModalMessage("Error", this.props[this.errorName].toString());
    });
    this.props.onClose();
  }

  render() {
    return (
      <ConfirmDialog
        show={this.props.show}
        onClose={this.props.onClose}
        title="License deactivating"
        question="Are you sure want to deactivate selected license?"
        onConfirm={this.onConfirm}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    permanentLicenseError: permanentLicensesSelectors.creatingUpdatingChangingError(state),
    temporaryLicenseError: temporaryLicensesSelectors.creatingUpdatingError(state)
  }
}

const actionCreators = {
  deactivatePermLic: permanentLicensesActions.deactivate,
  deactivateTempLic: temporaryLicensesActions.deactivate,
  showModalMessage: (title, text) => showModalMessage({ title, text }),
};

export default connect(mapStateToProps, actionCreators)(DeactivateLicConfirmDialog);



// WEBPACK FOOTER //
// ./src/containers/deactivateLicConfirmDialog.js